export enum LateFeeType {
    MissedDeadline = 1,
    DeadlineExtension = 2,
}
